module.exports = __webpack_public_path__ + "static/img/alipay.ff629077.png";